const __WEBPACK_NAMESPACE_OBJECT__ = __SOFIPO_BASE_DLL__.ReactDOMClient;